import { AnalyticsConfig } from './analytics.config';

let loadPromise: Promise<boolean> | null = null;

export function loadGtag(config: AnalyticsConfig): Promise<boolean> {
    if (!config.enabled) {
        return Promise.resolve(false);
    }
    if (typeof window === 'undefined') {
        return Promise.resolve(false);
    }
    if (loadPromise) {
        return loadPromise;
    }

    loadPromise = new Promise<boolean>((resolve) => {
        window.dataLayer = window.dataLayer || [];
        // Inline gtag shim must be a regular function to preserve `arguments`.
        window.gtag = function gtag() {
            // eslint-disable-next-line prefer-rest-params
            window.dataLayer!.push(arguments);
        };

        // Consent Mode v2 default — deve vir antes do primeiro `config`.
        window.gtag('consent', 'default', {
            analytics_storage: 'granted',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied'
        });

        window.gtag('js', new Date());
        window.gtag('config', config.measurementId, {
            send_page_view: false, // SPA controla page_view via router
            debug_mode: config.debug || undefined,
            anonymize_ip: true
        });

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(config.measurementId)}`;
        script.onload = () => resolve(true);
        script.onerror = () => {
            // Ad blocker ou falha de rede — graceful no-op.
            resolve(false);
        };
        document.head.appendChild(script);
    });

    return loadPromise;
}
